import { IBaseModel, BaseModel } from "../base.model";

export interface IDocumentModel {
  id?: number;
  type: string;
  fakeId: string;
  name: string;
  fk_attachment_type: number;
  file: FileReader;
}

export class DocumentModel implements IDocumentModel {
  id?: number;
  type: string;
  fakeId: string;
  name: string;
  fk_attachment_type: number;
  file: FileReader;

  private getBase64Url(file: File): FileReader {
    const fileReader: FileReader = new FileReader();
    fileReader.readAsDataURL(file)
    return fileReader
  }
  /**
   *
   */
  constructor(type: number, attachmentType: "document" | string, file: File) {
    this.type = attachmentType;
    this.name = file.name;
    this.fk_attachment_type = type;
  }
}


// WEBPACK FOOTER //
// ./src/models/documents/document.model.ts